// BrotherCard.js component. utilized for each class

import React from "react";
import PropTypes from 'prop-types';
import './BrotherCard.css';

const RectImgBox = ({broname, src, alt, majorGrad}) => {
    return (
        <div className="rectangle-image-box">
            <img src={src} alt={alt} />
            <div className="overlay">
                {alt}
                <p className="second-text">{majorGrad}</p>
            </div>
        </div>
    );
};

RectImgBox.propTypes = {
    broname: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    majorGrad: PropTypes.string.isRequired,
};

export default RectImgBox;